// src/pages/profile-settings/patient/EditEmail.jsx
import AccountEmailChange from "@/pages/profile-settings/AccountEmailChange.jsx";
import { PATIENT_SETTINGS_PROFILE_ROUTE } from "@/pages/profile-settings/settingsNavigation.js";

export default function EditEmail() {
  return <AccountEmailChange lane="patient" backRoute={PATIENT_SETTINGS_PROFILE_ROUTE} />;
}
